export default "__VITE_ASSET__f4978165__"